module.exports = __webpack_public_path__ + "static/img/culture-mission.d03316b3.png";